import { useAuth } from "../../../../AuthContext";
import React, { useState, useEffect, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";
import "../../../static/styles/observation.css";
import ObservationRightContainer from "./ObservationRightContainer";
import ObservationLeftContainer from "./ObservationLeftContainer";
import ObservationMap from "./ObservationMap";
import {ObservationContext} from './components/ObservationContext'
import Loading from "../../components/Loading/Loading";
import URLS from "../../../urls";
import { Box } from "@mui/material";

const Observation = ()  => {
  const M3_TO_BARREL = 6.2898;

  const { axiosInstance } = useAuth();
  const [observationData, setObservationData] = useState([]);
  const [AOI, setAOI] = useState(null);
  const [pipes, setPipes] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [leakSelected, setLeakSelected] = useState([]);
  const { observationSelected, setObservationSelected } =
    useContext(ObservationContext);
  let { leakId } = useParams();

  useEffect(() => {
    let url = URLS.OBSERVATION.MAIN + "?leak_id=" + leakId;
    fetchObservationAndGeometry(url);
  }, [leakId]);

  const volumeToBarrel = (data) => {
    return data.map((feature) => {
      feature.properties.volume = (
        feature.properties.volume * M3_TO_BARREL
      ).toFixed(2);
      return feature;
    });
  };

  const parseObservations = (data) => {
    let observations = data.features;
    observations = volumeToBarrel(observations);

    // ordena por fecha 
    if (observations.length > 1) {
      observations = data.features.sort((a, b) => {
        const dateA = new Date(a.properties.acquisition_info.date);
        const dateB = new Date(b.properties.acquisition_info.date);
        return dateB - dateA; 
      });
    }
    observations = observations.map((observation, index, array) => {
      const delta =
        index < array.length - 1
          ? (
              observation.properties.volume - array[index + 1].properties.volume
            ).toFixed(1)
          : null;
      return { ...observation, delta };
    });

    setObservationData(observations);
    setObservationSelected(observations[0]);
  };

  const fetchObservationAndGeometry = async (url) => {
    setIsLoading(true);
    try {
      const observationResponse = await axiosInstance.get(url);
      const selectedObservation = observationResponse.data.results.features[0];
      if(selectedObservation) {
        parseObservations(observationResponse.data.results);
        const [geometryResponse, pipesResponse, leakSelected] = await Promise.all([
          axiosInstance.get(`${URLS.AOI.MAIN}/${selectedObservation.properties.acquisition_info.aoi}`),
          axiosInstance.get(URLS.PIPE.MAIN),
          axiosInstance.get(`${URLS.LEAK.MAIN}/${leakId}`)
        ]);
        setAOI(geometryResponse.data);
        setPipes(pipesResponse.data.features);
        setLeakSelected(leakSelected.data);
      }
    } catch (error) {
      console.error("Hubo un error al realizar las llamadas a la API:", error);
      setObservationData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const memoizedObservationData = useMemo(
    () => observationData,
    [observationData]
  );
  const memoizedPipesGeoJSON = useMemo(() => pipes, [pipes]);

  return (
    <Box className="observation-app">
      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <>
          <Box className="observation-container">
              <ObservationLeftContainer
                observationData={memoizedObservationData}
                leakSelected={leakSelected}
              />
              <ObservationMap
                observationData={observationSelected}
                AOIGeoJSON={AOI}
                pipesGeoJSON={memoizedPipesGeoJSON}
              />
           </Box>
           {observationData && (
             <ObservationRightContainer
               observationData={memoizedObservationData}
             />
           )}
        </>
      )}
    </Box>
  );
}

export default Observation;
